const ROOTS = {
  AUTH: '/auth',
  OVERVIEW: '/overview',
  STOCK: '/stock',
  MANAGEMENT: '/management',
};

export const paths = {
  auth: {
    login: `${ROOTS.AUTH}/login`,
  },
  overview: {
    root: `${ROOTS.OVERVIEW}/report`,
    tradeTx: `${ROOTS.OVERVIEW}/trade-tx`,
    report: `${ROOTS.OVERVIEW}/report`,
    goldPrice: `${ROOTS.OVERVIEW}/gold-price`,
    position: `${ROOTS.OVERVIEW}/position`,
    redeem: `${ROOTS.OVERVIEW}/redeem`,
    deposit: `${ROOTS.OVERVIEW}/deposit`,
    topUpDeposit: `${ROOTS.OVERVIEW}/topup-deposit`,
    topupWithdraw: {
      root: `${ROOTS.OVERVIEW}/topup-withdraw`,
      detail: (id: string) => `${ROOTS.OVERVIEW}/topup-withdraw/${id}/detail`,
    },
    goldWithdraw: {
      root: `${ROOTS.OVERVIEW}/gold-withdraw`,
      detail: (id: string) => `${ROOTS.OVERVIEW}/gold-withdraw/${id}/detail`,
    },
    creditLoan: {
      root: `${ROOTS.OVERVIEW}/credit-loan`,
      create: `${ROOTS.OVERVIEW}/credit-loan/create`,
      detail: (id: string) => `${ROOTS.OVERVIEW}/credit-loan/${id}/detail`,
    },
    expiringTx: `${ROOTS.OVERVIEW}/expiring-tx`,
  },
  stock: {
    root: `${ROOTS.STOCK}`,
    summary: `${ROOTS.STOCK}/summary`,
    import: `${ROOTS.STOCK}/import`,
    export: `${ROOTS.STOCK}/export`,
    report: `${ROOTS.STOCK}/report`,
  },
  management: {
    user: {
      root: `${ROOTS.MANAGEMENT}/user`,
      edit: (id: string) => `${ROOTS.MANAGEMENT}/user/${id}/edit`,
    },
    product: {
      root: `${ROOTS.MANAGEMENT}/product`,
      detail: (id: string) => `${ROOTS.MANAGEMENT}/product/${id}/detail`,
      amount: (id: string) => `${ROOTS.MANAGEMENT}/product/${id}/amount`,
    },
    inviteCode: {
      root: `${ROOTS.MANAGEMENT}/invite-code`,
      create: `${ROOTS.MANAGEMENT}/invite-code/create`,
    },
    notification: `${ROOTS.MANAGEMENT}/notification`,
    setting: `${ROOTS.MANAGEMENT}/setting`,
  },
};
